// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.
import { FormHelperText } from "@material-ui/core";
import React from "react";

interface QuestionnaireInputErrorProps {
  error?: string | null;
}

export default (props: QuestionnaireInputErrorProps) => (
  <FormHelperText>{props.error} &nbsp;</FormHelperText>
);
